import {StampSignatureType} from '@core/api/data-access';

const StampSignatureOptions = [
	{value: StampSignatureType.NotAllowed, translationKey: 'pages.cw.fieldinfo.notAllowed'},
	{value: StampSignatureType.Required, translationKey: 'pages.sign-doc.attachments.required'},
	{value: StampSignatureType.Allowed, translationKey: 'pages.cw.fieldinfo.allowed'},
];

export default StampSignatureOptions;
